
import Draw from 'ol/interaction/Draw';
import VectorSource from 'ol/source/Vector';

function createInteractionDrawLine(options) {
    let source = new VectorSource({});

    let draw = new Draw({
        source: source,
        type: 'LineString'
    });

    draw.set('mapToolId', 'DrawLine');
    draw.setActive(false);

    draw.on('drawend', (e) => {
        if (options.onMapToolExecute) {
            options.onMapToolExecute(
                draw.get('mapToolId'),
                {
                    feature: e.feature
                }
            );
        }
    });

    return draw;
}

export default createInteractionDrawLine;
